<template>
  <section>
    <div v-if="fetching">
      <dh-loading-indicator />
    </div>
    <div class="null" v-if="!fetching">
      <div class="image" v-lazy:background-image="backgroundImage" />
      <div class="content" :class="{'reverse': reverse}">
        <h3 tabindex="0">{{ header }}</h3>
        <p aria-hidden="true">{{ bodyText }}</p>
      </div>
      <slot></slot>
    </div>
  </section>
</template>
<script>
import NullStates from '~/assets/images/null-states'

export default {
  props: {
    bodyText: {
      type: String,
      required: true
    },
    header: {
      type: String,
      required: true
    },
    reverse: {
      type: Boolean,
      required: false,
      default: false
    },
    fetching: {
      type: Boolean,
      required: false,
      default: false
    },
    image: {
      type: String,
      required: false,
      default: 'default',
      validator: value => Object.keys(NullStates).includes(value)
    }
  },
  computed: {
    backgroundImage () {
      return NullStates[this.image]
    }
  }
}
</script>

<style lang="scss" scoped>

section {
  flex-grow: 1;
}

.null {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: $bp-small;
  margin: auto;
  padding: $d-small 0;

  @include breakpoint(medium) {
    padding: $d-large 0;
  }

  .image {
    @include ratio(1,1);
    width: 160px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    margin-bottom: $d-small;
  }

  .content {

    h3 {
      @include font('050');
      @include deprecated-f-color-dark;
      margin-bottom: $d-x-small;
      text-align: center;
      font-weight: normal;
    }

    p {
      @include font('040');
      margin-bottom: $d-med;
      text-align: center;
    }

    &.reverse {
      display: flex;
      flex-direction: column-reverse;

      h3 {
        margin: 0 $d-small $d-med;
      }

      p {
        @include horizontal-lines();
      }
    }
  }
}
</style>
